import { supabase } from './supabaseClient';

export const fetchQueries = async () => {
    console.log('Fetching queries...');
    const { data, error } = await supabase
        .from('queries')
        .select('*')
        .order('created_at', { ascending: false });
    
    if (error) {
        console.error('Fetch error:', error);
        throw error; // Throw so the UI can catch it
    }
    console.log('Fetched data:', data);
    return data;
};

export const saveQuery = async (queryData) => {
    console.log('Saving query:', queryData);
    const { data, error } = await supabase
        .from('queries')
        .insert([queryData]);
    
    if (error) {
        console.error('Insert error:', error);
        throw error;
    }
    return data;
};

export const deleteQuery = async (id) => {
    const { error } = await supabase
        .from('queries')
        .delete()
        .eq('id', id);
    
    if (error) {
        throw error;
    }
    return true;
};

export const updateQueryStatus = async (id, status) => {
    const { error } = await supabase
        .from('queries')
        .update({ status })
        .eq('id', id);
    
    if (error) {
        throw error;
    }
    return true;
};
